import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * RouteChangeTracker Component
 * Tracks page views for SPA navigation using Google Analytics.
 *
 * IMPORTANT: GA4 auto page_view (send_page_view: true in index.html) already fires
 * the INITIAL pageview when the page first loads. To avoid double-counting, this
 * component skips the first location value it sees and only fires page_view for
 * subsequent client-side route changes.
 */
const RouteChangeTracker = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      // Skip the initial render — GA4 auto page_view already captured it.
      isFirstRender.current = false;
      return;
    }

    const pagePath = location.pathname + location.search;

    // Small delay to let the new page update document.title before we read it.
    const t = setTimeout(() => {
      trackPageView(pagePath, document.title);
    }, 100);

    return () => clearTimeout(t);
  }, [location]);

  return null;
};

export default RouteChangeTracker;
